import React, { useEffect, useState } from 'react';
import {
  addLitigiuByMeasure,
  deleteLitigiiByMeasure,
  getLitigii,
  getLitigiiByMeasure
} from '../../network/litigii';
import { IMeasure } from '../../utils/interfaces/interfaces';
import CButton from '../button/button';
import CDropdown from '../dropdown/dropdown';
import { Space } from '../utils/utils';
import styles from '../../pages/litigii/litigii.module.scss';
import { variables } from '../../utils/variables';
import CChip from '../chip/chip';
import { notify } from '../../notifications/notification';

interface ILitigii {
  measure: IMeasure;
  readOnly: boolean;
}
const LitigiiModal = (props: ILitigii) => {
  const [uniqueNumber, setUniqueNumber] = useState({
    litigiu: { id: 0 },
    id: 0
  });
  const [list, setList] = useState([]);
  const [litigii, setLitigii] = useState([]);

  useEffect(() => {
    getLitigii(1, '', '', '').then(({ data }) => {
      setList(data.data);
    });
    getLitigiiByMeasure(props.measure.id).then(({ data }) => {
      setLitigii(data.data);
    });
    // eslint-disable-next-line
  }, []);

  const handleDelete = (id: number) => {
    deleteLitigiiByMeasure(id);
    getLitigiiByMeasure(props.measure.id).then(({ data }) => {
      setLitigii(data.data);
      notify('Dosarul a fost șters cu succes.', 'success');
    });
  };

  const handleAdd = () => {
    uniqueNumber &&
      uniqueNumber.id !== 0 &&
      addLitigiuByMeasure(props.measure.id, uniqueNumber.id).then(() => {
        getLitigiiByMeasure(props.measure.id).then(({ data }) => {
          setLitigii(data.data);
          notify('Dosarul a fost adăugat cu succes.', 'success');
        });
      });
  };
  return (
    <div className={styles.litigiiForm}>
      <p className='subheading-dark bold'>Gestionare litigii</p>
      <Space vertical='30px' />
      {!props.readOnly && (
        <>
          <p className='body-dark'>
            Alege unul sau mai multe litigii pentru această măsură
          </p>
          <div className='col'>
            <CDropdown
              placeholder='Număr dosar unic'
              label=''
              list={list}
              currentOption={uniqueNumber}
              onChange={setUniqueNumber}
              visiblePhrase={el => (el ? `${el.uniqueFileNumber}` : '')}
            />
            <Space horizontal='30px' />
            <CButton type='submit' label='Adaugă' onClick={handleAdd} />
          </div>
        </>
      )}
      <div className={styles.listForm}>
        {litigii &&
          litigii.length > 0 &&
          litigii.map((litigiu: any) => (
            <CChip
              onRemoveId={() => handleDelete(litigiu.id)}
              label={litigiu.litigation.uniqueFileNumber}
              removable
            />
          ))}
      </div>
      <Space vertical={variables.verticalSpace} />
      <div className={styles.list}>
        {litigii && litigii.length === 0 && (
          <p className='body-dark'>Momentan nu aveti niciun dosar adaugat.</p>
        )}
      </div>
    </div>
  );
};

export default LitigiiModal;
